<template>
    <div v-if="parameters.isShowMax && maxLength !== Infinity">
        <a-textarea
            v-model="changeValue"
            :autoSize="autoSize"
            :maxLength="maxLength"
            :clearable="parameters.clearable"
            :placeholder="parameters.placeholder"
            @blur="onBlur"
            @focus="onFocus"
            @keyup.17="onKeyUp"
            @keypress="onKeyPress"
            @paste="onPaste"
            @change="onChange"
        >
        </a-textarea>
        <div style="text-align: right; line-height: 1.2; opacity: 0.6">
            {{ `${changeValue.length}/${maxLength}` }}
        </div>
    </div>
    <a-textarea
        v-else
        v-model="changeValue"
        :autoSize="autoSize"
        :maxLength="maxLength"
        :clearable="parameters.clearable"
        :placeholder="parameters.placeholder"
        @blur="onBlur"
        @focus="onFocus"
        @keyup.17="onKeyUp"
        @keypress="onKeyPress"
        @paste="onPaste"
        @change="onChange"
    >
    </a-textarea>
</template>

<script>
import { DataEntryMixin } from './mixins';
import { encryptedRender } from '@/utils/dynamic';
export default {
    name: 'SdTextarea',
    mixins: [DataEntryMixin],
    data(){
        return{
            isFocus: false, // 是否处于焦点状态
            isValidTrue: true, // 校验是否正确
            originValHidden: '',
            originVal: '',
            isEncryptField: true // 是否需要加密
        };
    },
    computed: {
        autoSize({ parameters }) {
            return {
                minRows: parameters.minRows || 4,
                maxRows: parameters.maxRows || 6,
            };
        },
        suffixStyle() {
            return {
                position: 'absolute',
                right: '12px',
                bottom: '0',
                userSelect: 'none',
                opacity: 0.6,
            };
        },
        maxLength({ parameters }) {
            return parameters.maxLength || parameters.maxLength === 0
                ? parameters.maxLength < 512 || parameters.maxLength === 512
                    ? parameters.maxLength
                    : 512
                : Infinity;
        },
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
        changeValue: {
            get() {
                if(!this.isFocus && this.isValidTrue){
                    if(!this.originVal){
                        this.originVal = this.value;
                    }
                    if(this.isEncryptField){
                        return encryptedRender(this.originVal);
                    }
                    else{
                        return this.originValHidden;
                    }
                }
                else{
                    return this.originValHidden;
                }
            },
            set(val) {
                this.originValHidden = val.trim();
                this.$emit('update:value', val.trim());
                this.$forceUpdate();
            },
        },
    },
    methods: {
        onBlur() {
            this.isFocus = false;
            this.$emit('onValidate');
        },
        onFocus(){
            this.isFocus = true;
        },
        onKeyPress(){
            // 代表有變動過，到保存之前都不加密
            console.log('11111111111');
            this.isEncryptField = false;
        },
        onKeyUp(){
            // 代表有變動過，到保存之前都不加密
            this.isEncryptField = false;
        },
        onPaste(){
            // 代表有變動過，到保存之前都不加密
            this.isEncryptField = false;
            console.log('粘貼');
        },
        onChange(){
            this.isEncryptField = false;
        }
    }
};
</script>

<style scoped lang="less"></style>
